"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingFieldReponse = void 0;
var ReportingFieldReponse;
(function (ReportingFieldReponse) {
    let valueType;
    (function (valueType) {
        valueType["NUMBER"] = "number";
        valueType["BIGINT"] = "bigint";
        valueType["PERCENTAGE"] = "percentage";
        valueType["CURRENCY"] = "currency";
        valueType["NUMBER_MAP"] = "number_map";
        valueType["BOOLEAN"] = "boolean";
        valueType["STRING"] = "string";
        valueType["UUID"] = "uuid";
        valueType["DATE"] = "date";
        valueType["REFERENCE"] = "reference";
        valueType["ENUM"] = "enum";
    })(valueType = ReportingFieldReponse.valueType || (ReportingFieldReponse.valueType = {}));
})(ReportingFieldReponse = exports.ReportingFieldReponse || (exports.ReportingFieldReponse = {}));
